export const rankVariables = [
  '--ds-rank-color-0',
  '--ds-rank-color-1',
  '--ds-rank-color-2',
  '--ds-rank-color-3',
  '--ds-rank-color-4',
] as const;
